<template>
  <div class="d-flex flex-column align-items-center">
    <h1 class="main-title display-4">Young Forever</h1>
    <h2 class="main-title">Katarzyna Bieńkowska</h2>
    <hr class="separator"/>
    <h3 class="secondary-title">mobilny gabinet kosmetyczny</h3>
  </div>
</template>

<script>
export default {
  name: 'section-left',
};
</script>

<style lang="scss" scoped>
@import '../../../../main.scss';

.main-title {
  @extend .font-weight-bold;
  @extend .my-2;
}

.secondary-title {
  @extend .text-lowercase;
  @extend .font-italic;
}
</style>



// WEBPACK FOOTER //
// SectionLeft.vue?45980caa